// 매입경로 프리셋 — 신고 372: 경매장 선택지 부재 → 4곳 추가.
// 저장: cars.buySource 자유 텍스트 컬럼 그대로 (서버 검증 없음). DB 변경 없음.
// CRA src/ 밖 import 제약 회피용 클라이언트 로컬 상수 (regions.js 동일 패턴).

export var BUY_SOURCE_PRESETS = ['헤이딜러제로', '셀프', '현대글로비스', '코오롱오토옥션', 'K카옥션', '롯데경매장'];
